import ProgressBarStep from "./ProgressBarStep";
import { faUser, faStoreAlt, faPaperPlane, faBookOpen } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { up } from "styled-breakpoints";
import { useLocation, Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";

const ProgressBarWrap = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 3em;
  font-size: 1.2em;

  ${up("md")} {
    margin-bottom: 2.5em;
    font-size: 0.85em;
  }

  ${up("lg")} {
    margin-bottom: 2.75em;
    font-size: 0.9em;
  }

  ${up("xl")} {
    margin-bottom: 3em;
  }

  ${up("xxl")} {
    margin-bottom: 3.5em;
    font-size: 1em;
  }

  ${up("giant")} {
    margin-bottom: 4em;
  }

  a {
    display: flex;
    flex: 1;
    color: black;
  }

  a:last-child {
    flex: 0;
  }
`;

function ProgressBar(props) {
  let location = useLocation();
  let navigate = useNavigate();

  const [cookies] = useCookies(["placeId"]);

  const getStartedClick = () => {
    if (cookies.authToken) {
      Swal.fire({
        title: "Your account has already been created",
        text: "You have already created your Eatsee account! To make changes, log in to your acocunt dashboard!",
        confirmButtonText: "Got it",
      });
    }
  };

  const menuSetupClick = () => {
    if (cookies.placeId === undefined) {
      Swal.fire({
        title: "You must enter your business details",
        text: "Enter your business details before proceeding to this step!",
        confirmButtonText: "Got it",
      });
    }
  };

  const finalClick = () => {
    if (cookies.placeId === undefined) {
      Swal.fire({
        title: "You must enter your business details",
        text: "Enter your business details before proceeding to this step!",
        confirmButtonText: "Got it",
      });
    }
  };

  return (
    <ProgressBarWrap>
      <Link to="/get-started" onClick={() => getStartedClick()} title="Step one">
        <ProgressBarStep icon={faUser} active={location.pathname === "/get-started" ? true : false} />
      </Link>
      <Link to="/business-profile" title="Step two">
        <ProgressBarStep icon={faStoreAlt} active={location.pathname === "/business-profile" ? true : false} />
      </Link>
      <Link
        to={!cookies.placeId ? "" : "/menu-builder"}
        onClick={() => menuSetupClick()}
        title="Step three"
      >
        <ProgressBarStep icon={faBookOpen} active={location.pathname.includes("/menu-builder") ? true : false} />
      </Link>
      <Link to={!cookies.placeId ? "" : "/finish"} onClick={() => finalClick()} title="Step four">
        <ProgressBarStep icon={faPaperPlane} last={true} active={location.pathname === "/finish" ? true : false} />
      </Link>
    </ProgressBarWrap>
  );
}

export default ProgressBar;
